import { render } from "./InsightsContentsPanel.vue?vue&type=template&id=6e1bf6c1&scoped=true"
import script from "./InsightsContentsPanel.vue?vue&type=script&lang=js"
export * from "./InsightsContentsPanel.vue?vue&type=script&lang=js"

import "./InsightsContentsPanel.vue?vue&type=style&index=0&id=6e1bf6c1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e1bf6c1"]])

export default __exports__